import React from 'react';
import { cn } from '../../lib/utils';
import { INTEGRATION_LOGOS } from '../../data/integrationsMock';

/** Fallback monograms if a partner logo asset is missing. */
const LOGO_STYLES = {
  dynamics: { label: 'Dy', background: 'linear-gradient(145deg, #002050 0%, #0078D4 100%)', color: '#fff' },
  economic: { label: 'e', background: '#1A1A1A', color: '#fff' },
  klaviyo: { label: 'Kl', background: 'linear-gradient(145deg, #1A1A1A 0%, #4B4B4B 100%)', color: '#fff' },
  hubspot: { label: 'Hs', background: '#FF7A59', color: '#fff' },
  quickbooks: { label: 'Qb', background: 'linear-gradient(145deg, #2CA01C 0%, #14800C 100%)', color: '#fff' },
  mobilepay: { label: 'Mp', background: '#5A78FF', color: '#fff' },
  nets: { label: 'Ne', background: '#00205B', color: '#fff' },
  klarna: { label: 'Kl', background: '#FFB3C7', color: '#0B051D' },
  visma: { label: 'Vi', background: '#E30613', color: '#fff' },
  fortnox: { label: 'Fx', background: '#1E88E5', color: '#fff' },
};

export function IntegrationLogo({ logoKey, name, src, size = 'md', className }) {
  const sizeClass = size === 'sm' ? 'h-9 w-9' : 'h-12 w-12';
  const labelClass = size === 'sm' ? 'text-[11px]' : 'text-sm';
  const resolvedSrc = src || INTEGRATION_LOGOS[logoKey] || null;

  if (resolvedSrc) {
    return (
      <div
        className={cn(
          'flex items-center justify-center overflow-hidden rounded-xl border border-slate-200 bg-white p-1.5 shadow-sm',
          sizeClass,
          className
        )}
      >
        <img src={resolvedSrc} alt="" className="h-full w-full object-contain" />
      </div>
    );
  }

  const style = LOGO_STYLES[logoKey] || {
    label: (name || '?').slice(0, 2),
    background: 'var(--brand-primary, #1A428A)',
    color: '#fff',
  };

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-xl shadow-sm ring-1 ring-black/5',
        sizeClass,
        className
      )}
      style={{ background: style.background, color: style.color }}
      aria-hidden="true"
      title={`${name} logo placeholder`}
    >
      <span className={cn('font-display font-bold tracking-tight', labelClass)}>{style.label}</span>
    </div>
  );
}
